import { render, staticRenderFns } from "./DoubleBarChart.vue?vue&type=template&id=d7e61518"
import script from "./DoubleBarChart.vue?vue&type=script&lang=ts"
export * from "./DoubleBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports